export const styles = {
  container: {
    position: 'fixed',
    top: '25px',
    left: '255px',
    mx: '20%',
    zIndex: '1300',
  },
  alert: {
    mb: '12px',
    boxShadow: '2px 2px 5px gray',
  },
};
